import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';
export const DeliveryOrder = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/trade/deliveryOrder`;
        return api.get(params, config);
    },
    // post: async function(params: any, config: ApiRequestConfig) {
    //     config.apiPath = `/display_category/${params.categoryId}/filter_attr`;
    //     return api.post(params, config);
    // },
    // delete: async function(params: any, config: ApiRequestConfig) {
    //     // console.log(params)
    //     const type = params.type;
    //     delete params.type;
    //     switch (type) {
    //         case 'all':
    //             config.apiPath = `/products/skuBlackList/export`;
    //             return api.get(params, config);
    //         case 'batch':
    //             config.apiPath = `/products/remove_black/${params.ids}`;
    //             // 对于批量操作要转发成POST
    //             return api.get(params, config);
    //         default:
    //             config.apiPath = `/products/remove_black/${params.id}`;
    //             return api.get(params, config);
    //             break;
    //     }

    //     return api.delete(params, config);
    // },
};
